// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m-0 {
  margin: 0 !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mr-0 {
  margin-right: 0 !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.ml-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mr-1 {
  margin-right: 0.25rem !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mr-2 {
  margin-right: 0.5rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mr-3 {
  margin-right: 1rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.ml-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mr-4 {
  margin-right: 1.5rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mr-5 {
  margin-right: 3rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.ml-5 {
  margin-left: 3rem !important;
}

.m-auto {
  margin: 0 auto;
}

.mx-1 {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}

.mx-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

.mx-3 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

.mx-4 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}

.mx-5 {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.my-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.my-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.my-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.my-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.my-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/margin.scss"],"names":[],"mappings":"AAAA;EACC,oBAAA;AACD;;AACA;EACC,wBAAA;AAED;;AACA;EACC,0BAAA;AAED;;AACA;EACC,2BAAA;AAED;;AACA;EACC,yBAAA;AAED;;AACA;EACC,0BAAA;AAED;;AACA;EACC,8BAAA;AAED;;AACA;EACC,gCAAA;AAED;;AACA;EACC,iCAAA;AAED;;AACA;EACC,+BAAA;AAED;;AACA;EACC,yBAAA;AAED;;AACA;EACC,6BAAA;AAED;;AACA;EACC,+BAAA;AAED;;AACA;EACC,gCAAA;AAED;;AACA;EACC,8BAAA;AAED;;AACA;EACC,uBAAA;AAED;;AACA;EACC,2BAAA;AAED;;AACA;EACC,6BAAA;AAED;;AACA;EACC,8BAAA;AAED;;AACA;EACC,4BAAA;AAED;;AACA;EACC,yBAAA;AAED;;AACA;EACC,6BAAA;AAED;;AACA;EACC,+BAAA;AAED;;AACA;EACC,gCAAA;AAED;;AACA;EACC,8BAAA;AAED;;AACA;EACC,uBAAA;AAED;;AACA;EACC,2BAAA;AAED;;AACA;EACC,6BAAA;AAED;;AACA;EACC,8BAAA;AAED;;AACA;EACC,4BAAA;AAED;;AACA;EACC,cAAA;AAED;;AACA;EACI,gCAAA;EACA,iCAAA;AAEJ;;AAAA;EACI,+BAAA;EACA,gCAAA;AAGJ;;AADA;EACI,6BAAA;EACA,8BAAA;AAIJ;;AAFA;EACI,+BAAA;EACA,gCAAA;AAKJ;;AAHA;EACI,6BAAA;EACA,8BAAA;AAMJ;;AAJA;EACI,+BAAA;EACA,kCAAA;AAOJ;;AALA;EACI,8BAAA;EACA,iCAAA;AAQJ;;AANA;EACI,4BAAA;EACA,+BAAA;AASJ;;AAPA;EACI,8BAAA;EACA,iCAAA;AAUJ;;AARA;EACI,4BAAA;EACA,+BAAA;AAWJ","sourcesContent":[".m-0 {\n\tmargin: 0 !important;\n}\n.mt-0 {\n\tmargin-top: 0 !important;\n}\n\n.mr-0 {\n\tmargin-right: 0 !important;\n}\n\n.mb-0 {\n\tmargin-bottom: 0 !important;\n}\n\n.ml-0 {\n\tmargin-left: 0 !important;\n}\n\n.m-1 {\n\tmargin: 0.25rem !important;\n}\n\n.mt-1 {\n\tmargin-top: 0.25rem !important;\n}\n\n.mr-1 {\n\tmargin-right: 0.25rem !important;\n}\n\n.mb-1 {\n\tmargin-bottom: 0.25rem !important;\n}\n\n.ml-1 {\n\tmargin-left: 0.25rem !important;\n}\n\n.m-2 {\n\tmargin: 0.5rem !important;\n}\n\n.mt-2 {\n\tmargin-top: 0.5rem !important;\n}\n\n.mr-2 {\n\tmargin-right: 0.5rem !important;\n}\n\n.mb-2 {\n\tmargin-bottom: 0.5rem !important;\n}\n\n.ml-2 {\n\tmargin-left: 0.5rem !important;\n}\n\n.m-3 {\n\tmargin: 1rem !important;\n}\n\n.mt-3 {\n\tmargin-top: 1rem !important;\n}\n\n.mr-3 {\n\tmargin-right: 1rem !important;\n}\n\n.mb-3 {\n\tmargin-bottom: 1rem !important;\n}\n\n.ml-3 {\n\tmargin-left: 1rem !important;\n}\n\n.m-4 {\n\tmargin: 1.5rem !important;\n}\n\n.mt-4 {\n\tmargin-top: 1.5rem !important;\n}\n\n.mr-4 {\n\tmargin-right: 1.5rem !important;\n}\n\n.mb-4 {\n\tmargin-bottom: 1.5rem !important;\n}\n\n.ml-4 {\n\tmargin-left: 1.5rem !important;\n}\n\n.m-5 {\n\tmargin: 3rem !important;\n}\n\n.mt-5 {\n\tmargin-top: 3rem !important;\n}\n\n.mr-5 {\n\tmargin-right: 3rem !important;\n}\n\n.mb-5 {\n\tmargin-bottom: 3rem !important;\n}\n\n.ml-5 {\n\tmargin-left: 3rem !important;\n}\n\n.m-auto {\n\tmargin: 0 auto;\n}\n\n.mx-1 {\n    padding-left: 0.25rem !important;\n    padding-right: 0.25rem !important;\n}\n.mx-2 {\n    padding-left: 0.5rem !important;\n    padding-right: 0.5rem !important;\n}\n.mx-3 {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n}\n.mx-4 {\n    padding-left: 1.5rem !important;\n    padding-right: 1.5rem !important;\n}\n.mx-5 {\n    padding-left: 3rem !important;\n    padding-right: 3rem !important;\n}\n.my-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n}\n.my-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n}\n.my-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n}\n.my-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n}\n.my-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
